<script setup lang="ts">
type Props = {
  name: string
  modelValue: string | null
  rules: string
}

const props = withDefaults(
  defineProps<Props>(), {},
)

const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()

const innerValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<template>
  <ValidationField
    v-slot:default="{ errors, handleChange }"
    v-model="innerValue"
    v-bind:name="name"
    v-bind:rules="rules"
    class="c-validationTextField"
    v-on:update:model-value="(val) => $emit('update:modelValue', val)"
  >
    <v-text-field
      v-bind="$attrs"
      v-bind:model-value="innerValue"
      v-bind:error-messages="errors"
      v-on:update:model-value="
        (e: string) => handleChange(e, errors.length > 0)
      "
      v-on:blur="handleChange"
    />
  </ValidationField>
</template>

<style scoped lang="scss">
:deep(.c-validationTextField) {
  .v-input {
    fieldset {
      border-width: 2px;
      border-radius: 6px;
      border-color: var(--color_border_control);
    }

    .v-input__slot {
      min-height: 47px !important;
    }

    .v-input__append-inner {
      margin-top: 12px !important;
    }

    &.error--text {
      fieldset {
        border-color: var(--color_border_control_error);
      }
    }
  }
}

:deep(.v-input__details) {
  padding-top: 4px !important;
}
</style>
